import { IonHeader } from "@ionic/react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: auto;
  padding: calc(3 * var(--u));
  background: url("/assets/ui/Header.png");
  background-size: auto 100%;
  background-repeat: repeat;
  background-position: left top;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (orientation: landscape) {
    height: 20vh;
  }
`;

const Logo = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;

  @media (orientation: landscape) {
    width: auto;
    height: 100%;
  }
`;

const BlockLink = styled(Link)`
  display: block;
  width: 100%;
  height: auto;

  @media (orientation: landscape) {
    width: auto;
    height: 100%;
  }
`;

const PortraitHeader = styled(IonHeader)<{ $shouldHide?: boolean }>`
  ${({ $shouldHide }) =>
    $shouldHide === true
      ? `
    @media (orientation: landscape) {
      display: none;
    }
  `
      : ""}
`;

export function Header(props: {
  size?: "small" | "big";
  shouldHide?: boolean;
}) {
  return (
    <PortraitHeader $shouldHide={props.shouldHide}>
      <Container>
        <BlockLink to="/">
          <Logo src="/assets/ui/Logo.png" />
        </BlockLink>
      </Container>
    </PortraitHeader>
  );
}
